import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions } from 'Actions/useractions';
import Logo from 'assets/images/logo.svg';
import { ReactComponent as ArrowDown } from 'assets/images/svg/arrow-icon.svg';
import svggenerator from 'Helpers/svggenerator';
import Image from 'Components/Common/Image';
import Popup from 'Components/Common/PopUp';
import OutsideClickHandler from 'react-outside-click-handler';

export const Header = (props) => {
	const [ showLogoutPopup, setShowLogoutPopup ] = useState(false);
	const [ showHeaderMenu, setShowHeaderMenu ] = useState(false);
	const history = useHistory();

	const togglemenu = () => {
		var menunav = document.getElementById('sidemenu1');
		menunav.classList.toggle('sidebarNav-active');
	};

	const logoutdispatch = (event) => {
		event.preventDefault();
		document.getElementById('logout').classList.add('disabled');
		props.logout();
	};

	const toggleLogoutConfirmPopup = () => {
		setShowLogoutPopup((val) => !val);
	};

	const redirectToPage = (path, e) => {
		e.stopPropagation();
		setShowHeaderMenu(false);
		if(typeof path === 'function'){
			path();
		}
		else{
			history.push(path);
		}
	}

	const { profile = {} } = props;
	const { image, userName } = profile;
	return (
		<>
		<header>
			<div className="humburger-menu-icon" onClick={ togglemenu }>
          		<span></span>
        	</div>
			
				<div className='header-area gap-10'>
					<div>
					<OutsideClickHandler
              onOutsideClick={ () => {
                setShowHeaderMenu(false);
              } }
            >
						<div className={ `profile_info ${ showHeaderMenu ? 'active' : '' }` }  onClick={ (e)=>{
							e.stopPropagation();
							setShowHeaderMenu(!showHeaderMenu);
						} }>
							<div className='profile_thumb'>
								<Image imageToken={ image } />
							</div>
							<div className='profile_name'>
								<h4>{ profile.name }</h4>
								<p>{ profile.email }</p>
							</div>
							<div className={ `profile-dropdown ${ showHeaderMenu ? 'active' : '' }` }>
								<span onClick={ (e) => redirectToPage('/profile/myprofile', e) }>My profile</span>
								<span onClick={ (e) => redirectToPage('/profile/changepassword', e) }>Change password</span>
								<span id='logout' onClick={ (e) => redirectToPage(toggleLogoutConfirmPopup, e) }>
									Logout
								</span>
							</div>
							<i className='arrow_icon'>
								<ArrowDown/>
								{/* <svg><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg> */}
							</i>
						</div>
						</OutsideClickHandler>
					</div>
				</div>
			{showLogoutPopup && (
				<Popup
					popupText='Are you sure you want to Logout?'
					handleYes={ logoutdispatch }
					handleCancel={ toggleLogoutConfirmPopup }
				/>
			)}
		</header>
		</>
	);
};
const mapStateToProps = (state) => {
	const { profile } = state;
	return { profile };
};

const mapDispatchToProps = {
	logout: userActions.logout,
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);